
/**
 * Creates an svg DOM element that is a reference to the svg icon in the svg definition
 */
export function svgIcon(id, className) {

    const svgNs = 'http://www.w3.org/2000/svg';
    const xlinkNs = 'http://www.w3.org/1999/xlink';

    let svg = document.createElementNS(svgNs, 'svg');

    if(className) {
        svg.setAttribute('class', className);
    }

    let use = document.createElementNS(svgNs, 'use');
    use.setAttributeNS(xlinkNs, 'href', `#${id}`);

    svg.appendChild(use);

    return svg;
}

export function getMetadata(name) {
    const metadata = document.querySelector(`meta[name='${name}'], meta[itemprop='${name}']`);

    return metadata ? metadata.getAttribute('content') : undefined;
}


// WEBPACK FOOTER //
// ./js/utils/DomUtils.js